import React         from 'react';
import { Observe }        from 'rewire-core';
import {
  DraggableResizableDialog
  as
  RewireDraggableResizableDialog,
  DraggableResizableDialogProps
  as
  RewireDraggableResizableDialogProps,
  IDraggableResizableDialogProps,
}                         from 'rewire-ui';
import {
  MuiThemeProvider,
}                         from '@material-ui/core/styles';
import {
  dialogTheme,
  dialogStyles,
}                         from './Dialog';
import                         './dialog.css';
import { withStyles }     from '../utility/styles';

class DraggableResizableDialog extends React.Component<RewireDraggableResizableDialogProps> {
  render() {
    const {children, ...restProps} = this.props;

    return <Observe render={() => (
      <MuiThemeProvider theme={dialogTheme}>
        <RewireDraggableResizableDialog {...restProps}>
          {children}
        </RewireDraggableResizableDialog>
      </MuiThemeProvider>
    )} />;
  }
}

export default withStyles<IDraggableResizableDialogProps>(dialogStyles, DraggableResizableDialog);
